import { TableCell } from "@mui/material";
import { type DataTableCellProps } from "../types";
import { CellDivider } from "../cell-divider";

export const DataTableCell = ({
  children,
  shrink = false,
  sx,
}: DataTableCellProps) => {
  return (
    <TableCell
      sx={{
        pl: 0.6,
        py: 0.32,
        pr: 0.32,
        minWidth: shrink ? null : "100px",
        position: "relative",
        fontSize: {
          xs: "0.86rem",
          md: "0.75rem",
        },
        ...sx,
      }}
    >
      {children}
      <CellDivider />
    </TableCell>
  );
};
